import styled from 'styled-components';

export const ColorChangePopup = styled.div`
    margin-bottom: 8px;
`;
